module.exports = __webpack_public_path__ + "static/media/12UNCTAD17.04515162.jpg";